export default __webpack_public_path__ + "static/media/participant-Background-min.285d872b.jpg";